<template>
  <TextField
    :label="$tt('previous_visa_num')"
    :hint="$tt('empty_if_unknown')"
    persistent-hint
  />
</template>